/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { PatchProjectsProjectidOptions, PatchProjectsProjectidResponses } from '../types/PatchProjectsProjectid'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /projects/:projectId}
 */
export function patchProjectsProjectid<ThrowOnError extends boolean = true>(options: Options<PatchProjectsProjectidOptions, ThrowOnError>): Unwrappable<RequestResult<PatchProjectsProjectidResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'PATCH', url: '/projects/{projectId}', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<PatchProjectsProjectidResponses, ThrowOnError>>)
}
